var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
import { MetaInfoBaseObject } from 'models';
import { plainToInstance } from 'class-transformer';
var AppointmentMetaInfo = /** @class */ (function (_super) {
    __extends(AppointmentMetaInfo, _super);
    function AppointmentMetaInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppointmentMetaInfo.prototype.getAppointmentStatuses = function () {
        return plainToInstance(MetaInfoBaseObject, this.appointment_statuses);
    };
    return AppointmentMetaInfo;
}(Model));
export default AppointmentMetaInfo;
